import {
  ElButton,
  ElDialog,
  ElPagination,
  ElTooltip,
  ElSelect,
  ElOption,
  ElAutocomplete,
  ElForm,
  ElFormItem,
  ElBadge,
  ElInput,
  ElBreadcrumb,
  ElBreadcrumbItem,
  ElTable,
  ElTableColumn,
  ElProgress,
  ElLoading,
  ElMenu,
  ElMenuItem,
  ElSubMenu,
  ElPopover,
  ElConfigProvider
} from 'element-plus'
import 'element-plus/theme-chalk/index.css'

export default {
  install(V: any): void {
    V.use(ElButton)
    V.use(ElDialog)
    V.use(ElPagination)
    V.use(ElTooltip)
    V.use(ElSelect)
    V.use(ElOption)
    V.use(ElAutocomplete)
    V.use(ElForm)
    V.use(ElFormItem)
    V.use(ElBadge)
    V.use(ElInput)
    V.use(ElBreadcrumb)
    V.use(ElBreadcrumbItem)
    V.use(ElTable)
    V.use(ElTableColumn)
    V.use(ElProgress)
    V.use(ElLoading)
    V.use(ElMenu)
    V.use(ElMenuItem)
    V.use(ElSubMenu)
    V.use(ElPopover)
    V.use(ElConfigProvider)
  }
}